var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"p-0 mb-0"},[_vm._v(" "+_vm._s(_vm.params.position)+" ")]),(_vm.params.featured)?_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v(" Featured ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }